import CheckIcon from '../../../../../public/assets/icons/check.svg';
import { Container } from './styles';

type Props = {
	checked: boolean;
};

export const Checkbox = ({ checked }: Props) => (
	<Container checked={checked}>{checked && <CheckIcon />}</Container>
);
